interface ScrollAnimationOptions {
    element: HTMLElement;
    targetPosition: number;
    duration: number;
    easing?: (t: number) => number;
    onComplete?: () => void;
    onCancel?: () => void;
}

export class ScrollAnimation {
    private startTime: number | null = null;
    private startPosition: number;
    private animationFrameId: number | null = null;

    constructor(private options: ScrollAnimationOptions) {
        this.startPosition = this.options.element.scrollTop;
        this.start();
    }

    private start(): void {
        this.startTime = performance.now();
        this.animationFrameId = requestAnimationFrame(this.animate);
    }

    private animate = (currentTime: number): void => {
        if (!this.startTime) {
            this.startTime = currentTime;
        }

        const elapsed = currentTime - this.startTime;
        const progress = Math.min(elapsed / this.options.duration, 1);
        const easedProgress = this.options.easing ? this.options.easing(progress) : progress;

        const currentPosition = this.startPosition + (this.options.targetPosition - this.startPosition) * easedProgress;
        this.options.element.scrollTop = currentPosition;

        if (progress < 1) {
            this.animationFrameId = requestAnimationFrame(this.animate);
        } else {
            this.options.onComplete?.();
        }
    };

    public cancel(): void {
        if (this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
            this.options.onCancel?.();
        }
    }
}

export const easeInOutCubic = (t: number): number =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

export const linear = (t: number): number => t;